module.exports = __webpack_public_path__ + "img/across.3afc398d.svg";